import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import axios from 'api/axios';
import SimpleBarReact from 'simplebar-react';
import { Spinner } from 'react-bootstrap';

import DefaultCard from 'components/mycomponents/DefaultCard';

const TodayActivity = () => {
    // Declare State Variable
    const [data, setData] = useState(null);
    const [loadingData, setLoadingData] = useState(false);

    // Declare Constant Variable
    const DATA_URL = '/vehicles';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    
    useEffect(() => {
        const getVehicleActivity = async () =>{
            setLoadingData(true);
            try {
                const response = await axios.get(`${DATA_URL}/activity`, {
                    headers: {
                      'Authorization': `Bearer ${TOKEN_APP}`
                    }
                  });
                const responseResult = response?.data;
                const responseData = responseResult?.data;

                setData(responseData);

                setLoadingData(false);
                
            } catch (err) {
                setLoadingData(false);
                if (err.response) {
                    const response = err.response.data;
                    console.log(response.message);
                } else {
                    console.log('Something error with server. Please call administrator or developer.');
                }
            }
        }

        getVehicleActivity()
    }, [TOKEN_APP]);

    return (
        <DefaultCard>
            <DefaultCard.Header title={'Aktivitas Hari Ini'} />
            <DefaultCard.Body>
                <SimpleBarReact style={{maxHeight: 200}}>    
                    <ul className="list-unstyled mb-0">
                        {
                            loadingData ? (<li className={`d-flex align-items-center fs--2 fw-medium pt-1 mb-1`}>
                                    <Spinner animation="border  " className="me-2" />
                                    <span className="fs-4">Loading ...</span>
                                </li>) :
                            data ? data.map((val, idx) => {
                                return (
                                    <li key={idx} className={`d-flex align-items-center fs--2 fw-medium pt-1 mb-1`}>
                                        <span
                                            className={`dot ${parseFloat(val.intstatus) === 1 ? 'bg-success' : parseFloat(val.intstatus) === 99 ? 'bg-warning' : 'bg-danger'}`}
                                        />
                                        <p className="lh-sm mb-0 text-700">
                                            <span className="text-900 ps-2">{val.vcnama} ({val.vcstatus})</span><br/>
                                            <span className="text-900 ps-2"><FontAwesomeIcon icon={faMapMarkerAlt}/> Posisi Terakhir: -</span>
                                        </p>
                                    </li>
                                )
                            }) : (<li className={`d-flex align-items-center fs--2 fw-medium pt-1 mb-1`}></li>)
                        }
                        {/* <li className={`d-flex align-items-center fs--2 fw-medium pt-1 mb-1`}>
                            <span
                                className={`dot bg-success`}
                            />
                            <p className="lh-sm mb-0 text-700">
                                <span className="text-900 ps-2">Bis 1 Off</span><br/>
                                <span className="text-900 ps-2"><FontAwesomeIcon icon={faMapMarkerAlt}/> Posisi Terakhir: Jl. Yosudarso</span>
                            </p>
                        </li>
                        <li className={`d-flex align-items-center fs--2 fw-medium pt-1 mb-1`}>
                            <span
                                className={`dot bg-success`}
                            />
                            <p className="lh-sm mb-0 text-700">
                                <span className="text-900 ps-2">Bis 1 Off</span><br/>
                                <span className="text-900 ps-2"><FontAwesomeIcon icon={faMapMarkerAlt}/> Posisi Terakhir: Jl. Yosudarso</span>
                            </p>
                        </li>
                        <li className={`d-flex align-items-center fs--2 fw-medium pt-1 mb-1`}>
                            <span
                                className={`dot bg-success`}
                            />
                            <p className="lh-sm mb-0 text-700">
                                <span className="text-900 ps-2">Bis 1 Off</span><br/>
                                <span className="text-900 ps-2"><FontAwesomeIcon icon={faMapMarkerAlt}/> Posisi Terakhir: Jl. Yosudarso</span>
                            </p>
                        </li>
                        <li className={`d-flex align-items-center fs--2 fw-medium pt-1 mb-1`}>
                            <span
                                className={`dot bg-success`}
                            />
                            <p className="lh-sm mb-0 text-700">
                                <span className="text-900 ps-2">Bis 1 Off</span><br/>
                                <span className="text-900 ps-2"><FontAwesomeIcon icon={faMapMarkerAlt}/> Posisi Terakhir: Jl. Yosudarso</span>
                            </p>
                        </li> */}
                    </ul>
                </SimpleBarReact>
            </DefaultCard.Body>
        </DefaultCard>
    )
}

TodayActivity.propTypes = {}

export default TodayActivity;